export default __webpack_public_path__ + "static/media/1824.6c15155a.png";